import { motion } from "framer-motion";
import { TrendingUp, ShieldAlert, Flame } from "lucide-react";
import { useLang } from "@/i18n";

const painIcons = [TrendingUp, ShieldAlert, Flame];

export default function Problem() {
  const { t } = useLang();
  const pains = t.problem.pains.map((p, i) => ({ ...p, icon: painIcons[i] }));

  return (
    <section id="problema" aria-labelledby="problem-heading" className="py-20 sm:py-28 scroll-mt-24 border-b border-red-400/20 bg-gradient-to-b from-red-500/[0.06] to-transparent" data-testid="problem-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-sm font-medium uppercase text-red-400" data-testid="problem-overline">
          {t.problem.overline}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
          id="problem-heading" data-testid="problem-heading"
          className="mt-4 font-display font-bold text-3xl sm:text-4xl lg:text-5xl max-w-3xl text-red-400"
        >
          {t.problem.h2}
        </motion.h2>

        <p className="mt-5 max-w-2xl text-sm sm:text-base text-steel leading-relaxed" data-testid="problem-intro">{t.problem.intro}</p>
        <div className="mt-12 grid md:grid-cols-3 gap-5 sm:gap-6">
            {pains.map((p, i) => (
              <motion.div
                key={p.title}
                initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.12 }}
                className="min-w-0 rounded-lg border border-red-400/20 border-t-2 border-t-red-400 bg-red-400/[0.04] p-6 lg:p-8" data-testid={`pain-card-${i}`}
              >
                <div className="flex flex-wrap items-center justify-between gap-4 text-red-400">
                  <p.icon aria-hidden="true" className="shrink-0" size={26} strokeWidth={1.5} />
                  <span className="font-display font-bold text-4xl lg:text-5xl" data-testid={`pain-metric-${i}`}>{p.num}</span>
                </div>
                <h3 className="mt-6 font-display font-semibold text-lg text-red-400" data-testid={`pain-title-${i}`}>{p.title}</h3>
                <p className="mt-3 text-sm text-steel leading-relaxed" data-testid={`pain-description-${i}`}>{p.text}</p>
              </motion.div>
            ))}
        </div>
      </div>
    </section>
  );
}
